// extracted by mini-css-extract-plugin
export default {"container":"AdminCustomers_container__qR-nw","statsGrid":"AdminCustomers_statsGrid__cOYiC"};